import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import Event from "@material-ui/icons/Event";
import Assessment from "@material-ui/icons/Assessment";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import AccountCircle from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer + 1,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },
}));

const NAV_ITEMS = [
  { label: "Inicio", to: "/", icon: HomeIcon },
  { label: "Eventos", to: "/proximos-eventos/", icon: Event },
  { label: "Resultados", to: "/resultados/", icon: Assessment },
  { label: "Retos", to: "/retos/", icon: EmojiEventsIcon },
];

export default function BottomNav() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const history = useHistory();
  const location = useLocation();
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);

  if (!isMobile) {
    return null;
  }

  const perfilTo = atleteAccount ? "/atletas/" : "/login";
  const items = [
    ...NAV_ITEMS,
    { label: "Perfil", to: perfilTo, icon: AccountCircle },
  ];

  const activeIndex = items.reduce((foundIndex, item, index) => {
    if (item.to === "/") {
      return location.pathname === "/" ? index : foundIndex;
    }
    return location.pathname.startsWith(item.to) ? index : foundIndex;
  }, 0);

  return (
    <BottomNavigation
      value={activeIndex}
      onChange={(event, newValue) => {
        history.push(items[newValue].to);
      }}
      showLabels
      className={classes.root}
    >
      {items.map(({ label, icon: Icon }) => (
        <BottomNavigationAction key={label} label={label} icon={<Icon />} />
      ))}
    </BottomNavigation>
  );
}
